module.exports = __webpack_public_path__ + "static/media/skype.2e9614d9.png";